"use strict";
import $ from "jquery";

const state = {
    unstarted: -1,
    ended: 0,
    playing: 1,
    paused: 2,
    buffering: 3,
    stop: 5,
};

function analytics(player, trigger) {
    if (!window.dataLayer) {
        return;
    }

    window.playertest = player;
    const apikey = "AIzaSyCXEWKMG8CretialnM18M0nSYRcsyodsMI";
    const videoId = $(player.getIframe()).data("ytSoruce");
    $.ajax({
        url: `//www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apikey}`,
        type: "GET",
    }).done(function (videoData) {
        const gtmEvent = {
            event: "YouTube Videos",
            eventCategory: "YouTube Videos",
            eventAction: null,
            eventLabel: "N/A",
        };

        switch (player.getPlayerState()) {
            case state.playing:
                gtmEvent.eventAction = "Play";
                break;
            case state.paused:
                gtmEvent.eventAction = "Pause";
                break;
            case state.ended:
                gtmEvent.eventAction = "Ended";
                break;
            default:
        }

        if (videoData.pageInfo.totalResults === 1) {
            gtmEvent.eventLabel = videoData.items[0].snippet.title;

            videoData.duration = player.getDuration();
            videoData.currentTime = player.getCurrentTime();

            if (trigger === "closeBtn") {
                gtmEvent.eventAction = "Stop";
            }

            if (gtmEvent.eventAction) {
                const percentagePlayed = (
                    (videoData.currentTime / videoData.duration) *
                    100
                ).toFixed(0);
                gtmEvent.eventAction = `${gtmEvent.eventAction} - ${Math.round(percentagePlayed / 25) * 25} %`;
            }
        }

        if (gtmEvent.eventAction) {
            window.dataLayer.push(gtmEvent);
        }
    });
}

function onPlayerReady(elm, event, index) {
    const player = event.target;

    if (index === 0 && window.location.search.search("autoplay=true") >= 0) {
        player.playVideo();
    }

    elm.find(".u-video-player__play-btn").on("click", () => {
        player.playVideo();
    });

    elm.find(".js-close").on("click", () => {
        analytics(player, "closeBtn");
        player.stopVideo();
        return false;
    });
}

function onPlayerStateChange(elm, event) {
    const player = event.target;
    const playerState = event.data;
    const playerContainer = elm.parents(".u-video-player");
    analytics(player);

    if (event.data === undefined) {
        console.error('Player state is undefined');
        return;
    }

    if (playerState === state.buffering) {
        playerContainer
            .find(".u-video-player__play-btn")
            .addClass("is-loading");
    }

    if (playerState === state.playing) {
        playerContainer.css("position", "static");
        playerContainer
            .find(".u-video-player__play-btn")
            .removeClass("is-loading");
        elm.addClass("video--active");

        if (
            !window.matchMedia("(max-width: 1024px)").matches &&
            elm.data("firstYTLoad") === undefined
        ) {
            elm.css({
                opacity: 1,
                display: "none", // eslint-disable-line
            });

            elm.data("firstYTLoad", true);
        }
        if (!window.matchMedia("(max-width: 768px)").matches) elm.slideDown();

        // This is needed to reflow IE - close button hides behind
        elm.find(".js-close").hide();
        setTimeout(function () {
            elm.find(".js-close").show();
        }, 100);
    } else if (playerState === state.ended || playerState === state.stop) {
        elm.removeClass("video--active");

        if (!window.matchMedia("(max-width: 768px)").matches) {
            elm.slideUp(function () {
                playerContainer.css("position", "relative");
            });
        } else {
            // With for css Transition to end.
            setTimeout(function () {
                playerContainer.css("position", "relative");
            }, 300);
        }
    }
}

function onYouTubeIframeAPIReady(elm){
    elm.each(function(index) {
        const $this = $(this);
        $this.css('position', 'relative');
        $this.find('iframe').attr({
            'src': $this.find('iframe').data('iframeSrc'),
            'id': 'yt-video' + index
        });

        new window.YT.Player('yt-video' + index, {
            playerVars: {
                'mute': 1
            },
            events: {
                onReady: (event) => {
                    onPlayerReady($this, event, index);
                },
                onStateChange: (event) => {
                    onPlayerStateChange($this.find('.u-video-player__iframe'), event);
                }
            }
        });
    });
}

function youtubeAPI() {
    const url = "//www.youtube.com/iframe_api";
    const id = "youtube-iframe-api";

    return new Promise(function (resolve, reject) {
        if (document.getElementById(id)) {
            resolve();
            return;
        }

        let pjs = document.getElementsByTagName("script")[0]; // eslint-disable-line
        let js = document.createElement("script"); // eslint-disable-line

        js.id = id;
        // js.onload = resolve;
        js.onerror = reject;
        js.src = url;

        pjs.parentNode.insertBefore(js, pjs);

        window.onYouTubeIframeAPIReady = () => {
            resolve();
        };
    });
}

function init() {
    const elm = $(".u-video-player");
    if (!elm.length) {
        return;
    }

    youtubeAPI()
        .then(() => {
            onYouTubeIframeAPIReady(elm);
        })
        .catch(() => {
            throw new Error("YouTube API failed to load.");
        });
}

export default {
    init,
};
